import moment from 'moment-timezone'

export const getTimeFromDecimal = t => {
  const hours = parseInt(t % 24)
  return `${hours < 10 ? `0${hours}` : hours}:${t % 1 > 0 ? '30' : '00'}`
}

export const getTimeForSelection = time => {
  return time ? time.replace(/^0+/, '') : null
}

// TODO: @Serginyo90 write tests
// must save date without relation to timezone for count correct start ProTrackLevel's date
export const convertDateToUTC = days => {
  const format = 'YYYY-MM-DD[T]00:00:00.[000Z]'
  return days.map(day => {
    return {
      ...day,
      startDate: day.startDate.format(format),
      endDate: day.endDate.format(format),
    }
  })
}

export const isDateToday = date => moment().isSame(date, 'day')
